module.exports = __webpack_public_path__ + "static/media/bg-notfound-desktop.d2543474.jpg";